import React from 'react';

function FeatureButtons() {
  return (
    <div className="buy-btn-wrapper">
      <div className="empty" />
      <button className="buy-btn" type="submit">
        Buy
      </button>
      <button className="buy-btn" type="submit">
        Buy
      </button>
      <button className="buy-btn" type="submit">
        Buy
      </button>
    </div>
  );
}

export default FeatureButtons;
